<template>
  <div
    class="detail-slider relative bg-scheme-main"
    :class="{
      'has-lightbox-open': isOpen,
    }"
  >
    <div
      class="pointer-events-none absolute right-3 top-3 z-30 rounded bg-black/40 p-1"
    >
      <SpriteSymbol name="expand" class="size-6 text-white" />
    </div>

    <div ref="flickingEl" class="flicking-viewport">
      <div class="flicking-camera">
        <a
          v-for="(image, index) in images"
          :key="index"
          class="mr-3 w-full cursor-zoom-in"
          :href="image.fileUrl?.path"
          :data-pswp-width="image.image?.width"
          :data-pswp-height="image.image?.height"
          :data-title="image.image?.title || image.image?.alt"
          draggable="false"
          tabindex="-1"
        >
          <MediaImage
            v-bind="image"
            image-class="aspect-video object-cover"
            responsive-style="hero_slider"
            no-draggable
          />
        </a>
      </div>
      <div v-if="isEnabled" class="absolute bottom-0 left-0 z-30 w-full p-3">
        <div class="flicking-pagination flex gap-2" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MediaImageFragment } from '#graphql-operations'

const props = defineProps<{
  nid?: string
  images: MediaImageFragment[]
}>()

const flickingEl = ref<HTMLDivElement>()

const persistKey = computed(() =>
  props.nid ? 'detail-slider-' + props.nid : null,
)

const isEnabled = computed(() => props.images.length > 1)

const { moveTo } = await useFlicking(flickingEl, {
  flickingOptions: {
    align: 'prev',
    circular: true,
  },
  persistKey,
  isEnabled,
  useAutoplayPagination: true,
})

const { isOpen } = await useLightbox(flickingEl, {
  onSlideChange(index) {
    moveTo(index, 0)
  },
})
</script>
